import { END_POINT } from "@constants/api.constants";
import { store } from "@src/store";

const { REFRESH_PASSWORD, MENUS } = END_POINT;

export const refreshPasswordAPI = async (payload) => {
  return await fetch(REFRESH_PASSWORD, {
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.status === true)
        return {
          token: data.data.token,
          user: data.data.user,
          status: data.status,
        };
      else return { status: false, message: data.message };
    })
    .catch(function (error) {
      return {
        status: false,
        message: "Something went wrong from login api",
        error,
      };
    });
};

export const getTokenDataAPI = async () => {
  return await fetch(MENUS, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      token: store.getState().app.token,
    },
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.status === false)
        return {
          data: data.data,
          status: true,
        };
      else return { status: false, message: data.message };
    })
    .catch(function (error) {
      return {
        status: false,
        message: "Something went wrong from login api",
        error,
      };
    });
};
